import axios from 'axios';
import config from '../config/sbf_config';

let instanceLeadsApi;

export const leadsServiceApi = async (params) => {
    const key = config.featureToggles.globalAuth ? 'token' : 'jwtToken';
    const jwtToken = localStorage.getItem(key);

    if (!instanceLeadsApi) {
        instanceLeadsApi = axios.create({
            baseURL: `${config.leadServiceUrl}/api/v1/`,
        });
    }

    return instanceLeadsApi({
        ...params,
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        },
    });
};



// WEBPACK FOOTER //
// ./src/infra/purchasingApi.service.js